import Button from "@acko-tech/building-blocks.ui.button-old";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const DiscountCardWrapper = styled(Box)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 12px;
  border: 2px solid transparent;
  background: linear-gradient(276deg, #fffef0 0.25%, #fdf7ff 99.71%) padding-box, linear-gradient(96deg, #F5B7FF, #FDC7E7, #FCE2B1, #FFABD5) border-box;
  backdrop-filter: blur(10px);
  width: 100%;
`;

export const HeadingText = styled(Text)`
  font-size: 12px;
  color: #5b5675;
  text-align: right;
`;

export const DiscountTag = styled(Box)`
  background: #fbe9f6;
  padding: 0px 12px;
  border-radius: 24px;
  width: auto;
  height: 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
`;

export const DiscountTagText = styled(Text)`
  background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
  font-size: 12px;
  font-weight: 600;
  background-clip: text;
  line-height: 18px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const DiscountCardHeading = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  padding-top: 4px;
  font-size: ${(props) => (props.isSpecialDiscount ? "18px" : "20px")};
  line-height: ${(props) => (props.isSpecialDiscount ? "24px" : "28px")};
  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const ApplyDiscountButton = styled(Button)`
  margin-top: 12px;
  color: #040222;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.1px;
  width: 134px;
  height: 40px;
  background: none;
  border-radius: 8px;
  padding: 8px 8px;
  border: 1px solid var(--Neutral-N600, #040222);
  font-family: 'Euclid Circular B';
  :hover {
    background-color: inherit;
    border: 1px solid var(--Neutral-N600, #040222);
    color: #040222;
  }
`;

export const DiscountPara = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #36354c;
  margin-top: 4px;
  @media (max-width: 767px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const AppliedDiscountText = styled(Text)`
  color: #0fa457;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-left: 4px;
`;

export const RenoveDiscountButton = styled(Button)`
  color: #d83d37;
  background: none;
  border: none;
  padding: 0px;
  font-weight: 500;
  font-size: 14px;
  font-family: 'Euclid Circular B';

  :hover {
    background-color: inherit;
    border: none;
    color: #d83d37;
  }
`;

interface AppliedDiscountTextWrapperProps {
  isSpecialDiscount: boolean;
}

export const AppliedDiscountTextWrapper = styled(Box) <AppliedDiscountTextWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${(props) => (props.isSpecialDiscount ? "0px" : "24px")};

  @media (max-width: 767px) {
    margin-top: ${(props) => (props.isSpecialDiscount ? "0px" : "20px")};
  }
`;

export const DiscountImage = styled.img`
  width: 56px;
  height: 56px;

  @media (max-width: 767px) {
    width: 48px;
    height: 48px;
  }
`;
